import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3363517071/src/src/app/@travelCardModal/(...)travelCard/[id]/page.tsx");
